import { createConnector } from 'wagmi';
import { walletConnect } from 'wagmi/connectors';
const walletConnectInstances = new Map();
// Function to get or create a walletConnect instance
const getOrCreateWalletConnectInstance = ({ projectId, walletConnectParameters, capsuleDetailsShowQrModal, }) => {
    let config = Object.assign(Object.assign({}, (walletConnectParameters ? walletConnectParameters : {})), { projectId, showQrModal: false });
    // `capsuleDetailsShowQrModal` should always be `true`
    if (capsuleDetailsShowQrModal) {
        config = Object.assign(Object.assign({}, config), { showQrModal: true });
    }
    const serializedConfig = JSON.stringify(config);
    const sharedWalletConnector = walletConnectInstances.get(serializedConfig);
    if (sharedWalletConnector) {
        return sharedWalletConnector;
    }
    // Create a new walletConnect instance and store it
    const newWalletConnectInstance = walletConnect(config);
    walletConnectInstances.set(serializedConfig, newWalletConnectInstance);
    return newWalletConnectInstance;
};
// Creates a WalletConnect connector with the given project ID and additional options.
function createWalletConnectConnector({ projectId, walletDetails, walletConnectParameters, }) {
    // Create and configure the WalletConnect connector with project ID and options.
    return createConnector(config => (Object.assign(Object.assign(Object.assign({}, getOrCreateWalletConnectInstance({
        projectId,
        walletConnectParameters,
        // Used in `connectorsForWallets` to add another
        // walletConnect wallet into capsule with modal popup option
        capsuleDetailsShowQrModal: walletDetails.capsuleDetails.showQrModal,
    })(config)), walletDetails), { id: walletDetails.capsuleDetails.id })));
}
// Factory function to obtain a configured WalletConnect connector.
export function getWalletConnectConnector({ projectId, walletConnectParameters, }) {
    if (!projectId || projectId === '') {
        throw new Error('No projectId found. Every dApp must now provide a WalletConnect Cloud projectId to enable WalletConnect v2. Sign up for your free key at https://cloud.walletconnect.com/sign-in');
    }
    // Return a function that merges additional wallet details with `CreateConnectorFn`.
    return (walletDetails) => createWalletConnectConnector({
        projectId,
        walletDetails,
        walletConnectParameters,
    });
}
